import { Link } from "@tanstack/react-router";
import { Bell, Loader2, CheckCheck, Dot } from "lucide-react";
import { useNotifications, useMarkRead, useMarkAllRead } from "../api/notifications";

export function NotificationsPage() {
  const { data, isLoading } = useNotifications();
  const markRead = useMarkRead();
  const markAll = useMarkAllRead();

  return (
    <div className="p-8 h-full flex flex-col gap-5 min-h-0 overflow-auto">
      <header className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-black flex items-center gap-3 text-slate-900">
            <Bell size={26} className="text-brand-700" /> Notificaciones
            {data?.no_leidas ? (
              <span className="rounded-full bg-rose-100 text-rose-700 px-2.5 py-0.5 text-sm">{data.no_leidas}</span>
            ) : null}
          </h1>
          <p className="text-slate-500 mt-1">Avisos del asistente y de la actividad de tu equipo.</p>
        </div>
        {data?.no_leidas ? (
          <button
            onClick={() => markAll.mutate()}
            className="inline-flex items-center gap-2 rounded-xl border border-slate-300 hover:bg-slate-50 px-4 py-2 text-sm font-bold text-slate-700"
          >
            <CheckCheck size={16} /> Marcar todas como leídas
          </button>
        ) : null}
      </header>

      {isLoading ? (
        <div className="flex items-center gap-2 text-slate-500"><Loader2 className="animate-spin" size={18} /> Cargando…</div>
      ) : !data?.data.length ? (
        <div className="grid place-items-center py-20 text-center text-slate-400">
          <Bell size={40} className="mb-3" />
          <p className="font-bold text-slate-600">No tienes notificaciones.</p>
        </div>
      ) : (
        <div className="rounded-2xl border border-slate-200/70 bg-white divide-y divide-slate-100 max-w-3xl">
          {data.data.map((n) => {
            const noLeida = !n.leida_en;
            const Wrapper = n.url ? Link : "div";
            return (
              <Wrapper
                key={n.id}
                {...(n.url ? { to: n.url } : {})}
                onClick={() => noLeida && markRead.mutate(n.id)}
                className={`flex items-start gap-3 px-4 py-3 ${n.url ? "hover:bg-slate-50 cursor-pointer" : ""} ${noLeida ? "bg-brand-50/40" : ""}`}
              >
                <div className="pt-1">
                  {noLeida ? <Dot size={20} className="text-brand-600" /> : <Dot size={20} className="text-transparent" />}
                </div>
                <div className="min-w-0 flex-1">
                  <div className={`text-sm ${noLeida ? "font-black text-slate-900" : "font-semibold text-slate-700"}`}>{n.titulo}</div>
                  {n.mensaje && <div className="text-sm text-slate-500 mt-0.5">{n.mensaje}</div>}
                  <div className="text-xs text-slate-400 mt-1">{new Date(n.creado_en).toLocaleString("es-ES")}</div>
                </div>
              </Wrapper>
            );
          })}
        </div>
      )}
    </div>
  );
}
